const { PERMISSIONS } = require('./permissions');

const ROLE_GATE = {
  [PERMISSIONS.DASHBOARD_COUPON]: shop => shop.enableCoupon,
  [PERMISSIONS.DASHBOARD_PACKAGE]: shop => shop.enablePackage,
  [PERMISSIONS.DASHBOARD_PROMOTION]: shop => shop.enablePromotion,
  [PERMISSIONS.DASHBOARD_WALLET]: shop => shop.enableWallet,

  [PERMISSIONS.CONTACT_VIEW]: shop => shop.contactEnabled,
  [PERMISSIONS.CONTACT_TEMPLATE_MANAGEMENT]: shop => shop.contactEnabled,
  [PERMISSIONS.CONTACT_CAN_ASSIGN]: shop => shop.contactEnabled,
  [PERMISSIONS.CONTACT_CAN_EDIT_BOARD]: shop => shop.contactEnabled,

  [PERMISSIONS.BROADCAST_VIEW]: shop => shop.enableWhatsapp || shop.enableLineNotification,
  [PERMISSIONS.BROADCAST_VIEW_HISTORY]: shop => shop.enableWhatsapp || shop.enableLineNotification,
  [PERMISSIONS.BROADCAST_CREATE_WHATSAPP]: shop => shop.enableWhatsapp,
  [PERMISSIONS.BROADCAST_CREATE_LINE]: shop => shop.enableLineNotification,
  [PERMISSIONS.BROADCAST_EDIT]: shop => shop.enableWhatsapp || shop.enableLineNotification,
  [PERMISSIONS.BROADCAST_DELETE]: shop => shop.enableWhatsapp || shop.enableLineNotification,
  [PERMISSIONS.BROADCAST_RECURRING_VIEW]: shop =>
    (shop.enableWhatsapp || shop.enableLineNotification) && shop.enableRecurringBroadcast,
  [PERMISSIONS.BROADCAST_RECURRING_CREATE]: shop =>
    (shop.enableWhatsapp || shop.enableLineNotification) && shop.enableRecurringBroadcast,
  [PERMISSIONS.BROADCAST_RECURRING_EDIT]: shop =>
    (shop.enableWhatsapp || shop.enableLineNotification) && shop.enableRecurringBroadcast,
  [PERMISSIONS.BROADCAST_RECURRING_CHANGE_STATUS]: shop =>
    (shop.enableWhatsapp || shop.enableLineNotification) && shop.enableRecurringBroadcast,
  [PERMISSIONS.BROADCAST_RECURRING_VIEW_HISTORY]: shop =>
    (shop.enableWhatsapp || shop.enableLineNotification) && shop.enableRecurringBroadcast,

  [PERMISSIONS.SHOP_PRODUCT_VIEW_LIST]: shop => shop.enableShoppingCart,
  [PERMISSIONS.SHOP_PRODUCT_CREATE]: shop => shop.enableShoppingCart,
  [PERMISSIONS.SHOP_PRODUCT_EDIT]: shop => shop.enableShoppingCart,
  [PERMISSIONS.SHOP_PRODUCT_VIEW_CATEGORY]: shop => shop.enableShoppingCart,
  [PERMISSIONS.SHOP_PRODUCT_CREATE_CATEGORY]: shop => shop.enableShoppingCart,
  [PERMISSIONS.SHOP_PRODUCT_EDIT_CATEGORY]: shop => shop.enableShoppingCart,
  [PERMISSIONS.SHOP_PRODUCT_DELETE_CATEGORY]: shop => shop.enableShoppingCart,
  [PERMISSIONS.SHOP_PRODUCT_CHANGE_STATUS]: shop => shop.enableShoppingCart,
  [PERMISSIONS.SHOP_PRODUCT_VIEW_STOCK]: shop => shop.enableShoppingCart,
  [PERMISSIONS.SHOP_PRODUCT_VIEW_STOCK_HISTORY]: shop => shop.enableShoppingCart,
  [PERMISSIONS.SHOP_PRODUCT_ADD_ON_VIEW]: shop => shop.enableShoppingCart,
  [PERMISSIONS.SHOP_PRODUCT_ADD_ON_CREATE]: shop => shop.enableShoppingCart,
  [PERMISSIONS.SHOP_PRODUCT_ADD_ON_EDIT]: shop => shop.enableShoppingCart,
  [PERMISSIONS.SHOP_PRODUCT_ADD_ON_GROUP_VIEW]: shop => shop.enableShoppingCart,
  [PERMISSIONS.SHOP_PRODUCT_ADD_ON_GROUP_CREATE]: shop => shop.enableShoppingCart,
  [PERMISSIONS.SHOP_PRODUCT_ADD_ON_GROUP_EDIT]: shop => shop.enableShoppingCart,
  [PERMISSIONS.SHOP_PRODUCT_ADD_ON_GROUP_DELETE]: shop => shop.enableShoppingCart,
  [PERMISSIONS.SHOP_PRODUCT_EDIT_STOCK]: shop => shop.enableShoppingCart,
  [PERMISSIONS.SHOPPING_PAYMENT_SETTING_EDIT]: shop => shop.enableShoppingCart,
  [PERMISSIONS.SHOPPING_PAYMENT_SETTING_VIEW]: shop => shop.enableShoppingCart,
  [PERMISSIONS.SHOPPING_SHIPPING_MANAGEMENT_EDIT]: shop => shop.enableShoppingCart,
  [PERMISSIONS.SHOPPING_SHIPPING_MANAGEMENT_VIEW]: shop => shop.enableShoppingCart,
  [PERMISSIONS.SHOPPING_CART_SETTING_EDIT]: shop => shop.enableShoppingCart,
  [PERMISSIONS.SHOPPING_CART_SETTING_VIEW]: shop => shop.enableShoppingCart,
  [PERMISSIONS.SHOPPING_ORDER_VIEW]: shop => shop.enableShoppingCart,
  //
  [PERMISSIONS.BOOKING_MANAGEMENT]: shop => shop.isBooking,
  [PERMISSIONS.BOOKING_SETTING]: shop => shop.isBooking,
  [PERMISSIONS.BOOKING_INVITE]: shop => shop.isBooking,
  [PERMISSIONS.BOOKING2_MANAGEMENT]: shop => shop.isBooking2,
  [PERMISSIONS.BOOKING2_SETTING]: shop => shop.isBooking2,
  [PERMISSIONS.BOOKING2_INVITE]: shop => shop.isBooking2,
  [PERMISSIONS.PACKAGE_VIEW]: shop => shop.enablePackage,
  [PERMISSIONS.PACKAGE_CREATE]: shop => shop.enablePackage,
  [PERMISSIONS.PACKAGE_EDIT]: shop => shop.enablePackage,
  [PERMISSIONS.PACKAGE_CHANGE_STATUS]: shop => shop.enablePackage,
  [PERMISSIONS.PACKAGE_REDEEM]: shop => shop.enablePackage,
  [PERMISSIONS.PACKAGE_VIEW_CUSTOMER_ITEMS]: shop => shop.enablePackage,
  [PERMISSIONS.PACKAGE_VIEW_CUSTOMER_HISTORY]: shop => shop.enablePackage,
  //
  [PERMISSIONS.PROMOTION_VIEW]: shop => shop.enablePromotion,
  [PERMISSIONS.PROMOTION_CREATE]: shop => shop.enablePromotion,
  [PERMISSIONS.PROMOTION_EDIT]: shop => shop.enablePromotion,
  [PERMISSIONS.PROMOTION_CHANGE_STATUS]: shop => shop.enablePromotion,
  [PERMISSIONS.PROMOTION_VIEW_CUSTOMERS]: shop => shop.enablePromotion,
  //
  [PERMISSIONS.COUPON_VIEW]: shop => shop.enableCoupon,
  [PERMISSIONS.COUPON_CREATE]: shop => shop.enableCoupon,
  [PERMISSIONS.COUPON_EDIT]: shop => shop.enableCoupon,
  [PERMISSIONS.COUPON_DELETE]: shop => shop.enableCoupon,
  [PERMISSIONS.COUPON_CHANGE_STATUS]: shop => shop.enableCoupon,
  [PERMISSIONS.COUPON_VIEW_HISTORY]: shop => shop.enableCoupon,
  [PERMISSIONS.COUPON_VIEW_CUSTOMER_HISTORY]: shop => shop.enableCoupon,
  [PERMISSIONS.COUPON_USE_FOR_CUSTOMERS]: shop => shop.enableCoupon,
  //
  [PERMISSIONS.WALLET_ADD_BY_CUSTOMER]: shop => shop.enableWallet,
  [PERMISSIONS.WALLET_ADD_BY_PHONE]: shop => shop.enableWallet,
  [PERMISSIONS.WALLET_ADD_BY_QR]: shop => shop.enableWallet,
  [PERMISSIONS.WALLET_HISTORY]: shop => shop.enableWallet,
  [PERMISSIONS.WALLET_VIEW_CUSTOMER_HISTORY]: shop => shop.enableWallet,
  [PERMISSIONS.WALLET_EXPIRABLE_VIEW_CUSTOMER_HISTORY]: shop => shop.enableWallet,
  //
  [PERMISSIONS.RECOMMENDER_QR_VIEW]: shop => shop.enableSalesQr,
  [PERMISSIONS.RECOMMENDER_QR_CREATE]: shop => shop.enableSalesQr,
  [PERMISSIONS.RECOMMENDER_QR_EDIT]: shop => shop.enableSalesQr,
  [PERMISSIONS.RECOMMENDER_QR_DELETE]: shop => shop.enableSalesQr,
  [PERMISSIONS.RECOMMENDER_QR_VIEW]: shop => shop.enableSalesQr,
  //
  [PERMISSIONS.MGM_MANAGEMENT]: shop => shop.enableMGM,
  [PERMISSIONS.MGM_VIEW_HISTORY]: shop => shop.enableMGM,
  [PERMISSIONS.MGM_VIEW_REPORT]: shop => shop.enableMGM,
  [PERMISSIONS.MGM_VIEW_CUSTOMER_HISTORY]: shop => shop.enableMGM,
  //
  [PERMISSIONS.FUNSHARING_VIEW_LIST]: shop => shop.enableFunsharing,
  [PERMISSIONS.FUNSHARING_CREATE]: shop => shop.enableFunsharing,
  [PERMISSIONS.FUNSHARING_EDIT]: shop => shop.enableFunsharing,
  [PERMISSIONS.FUNSHARING_VIEW_HISTORY]: shop => shop.enableFunsharing,
  [PERMISSIONS.FUNSHARING_VIEW_REPORT]: shop => shop.enableFunsharing,
  [PERMISSIONS.FUNSHARING_VIEW_CUSTOMER_HISTORY]: shop => shop.enableFunsharing,
  //
  [PERMISSIONS.WALLET_ADD_BY_CUSTOMER]: shop => shop.enableWallet,
  [PERMISSIONS.WALLET_HISTORY]: shop => shop.enableWallet,

  //ai
  [PERMISSIONS.AI_MANAGEMENT]: shop => shop.enableAI,

  //report
  [PERMISSIONS.REPORT_WALLET_HISTORY]: shop => shop.enableWallet,
  [PERMISSIONS.REPORT_SALES_HISTORY]: shop => shop.enableShoppingCart,
  [PERMISSIONS.REPORT_REDEEM]: shop => shop.enablePromotion,
  [PERMISSIONS.REPORT_COUPON_SHOP]: shop => shop.enableCoupon,
  [PERMISSIONS.REPORT_COUPON_USAGE]: shop => shop.enableCoupon,
  [PERMISSIONS.REPORT_PACKAGE_SHOP]: shop => shop.enablePackage,
  [PERMISSIONS.REPORT_PACKAGE_CUSTOMER]: shop => shop.enablePackage,
  [PERMISSIONS.REPORT_PACKAGE_USAGE_HISTORY]: shop => shop.enablePackage,
  [PERMISSIONS.REPORT_BOOKING_HISTORY]: shop => shop.isBooking,
  [PERMISSIONS.REPORT_BOOKING2_HISTORY]: shop => shop.isBooking2,
  [PERMISSIONS.REPORT_ORDER_DETAIL]: shop => shop.enableShoppingCart || shop.enableMiniPos,
  [PERMISSIONS.REPORT_ORDER_ITEMS]: shop => shop.enableShoppingCart || shop.enableMiniPos,
  [PERMISSIONS.REPORT_ORDER_SUMMARY]: shop => shop.enableShoppingCart || shop.enableMiniPos,
  [PERMISSIONS.REPORT_STOCK_INVENTORY]: shop => shop.enableShoppingCart,
  [PERMISSIONS.REPORT_STOCK_TRANSACTION]: shop => shop.enableShoppingCart,
  [PERMISSIONS.REPORT_COMMISSION_ENTRIES]: shop => shop.enableCommission,
  [PERMISSIONS.REPORT_COMMISSION_SUMMARY]: shop => shop.enableCommission,

  //smart pos
  [PERMISSIONS.SMART_POS_FULL_ACCESS]: shop => shop.enableSmartPos,

  //minipos
  [PERMISSIONS.MINIPOS_ACCESS]: shop => shop.enableMiniPos,

  //upload
  [PERMISSIONS.UPLOAD_ACCESS]: shop => shop.enableUploadFile,
  [PERMISSIONS.UPLOAD_ADD_MEMBER]: shop => shop.enableUploadFile,
  [PERMISSIONS.UPLOAD_ADD_POINT]: shop => shop.enableUploadFile,
  [PERMISSIONS.UPLOAD_ADD_GROUP]: shop => shop.enableUploadFile,
  [PERMISSIONS.UPLOAD_ADD_SHOP_PRODUCT]: shop => shop.enableUploadFile && shop.enableShoppingCart,
  [PERMISSIONS.UPLOAD_ADD_SHOP_PRODUCT_STOCK]: shop => shop.enableUploadFile && shop.enableShoppingCart,
  [PERMISSIONS.UPLOAD_ADD_SHOP_PRODUCT_CATEGORY]: shop => shop.enableUploadFile && shop.enableShoppingCart,
  [PERMISSIONS.UPLOAD_ADD_PACKAGE]: shop => shop.enableUploadFile && shop.enablePackage,
  [PERMISSIONS.UPLOAD_ADD_PROMOTION]: shop => shop.enableUploadFile && shop.enablePromotion,
  [PERMISSIONS.UPLOAD_ADD_COUPON]: shop => shop.enableUploadFile && shop.enableCoupon,
  [PERMISSIONS.UPLOAD_ADD_DEPOSIT]: shop => shop.enableUploadFile,
  [PERMISSIONS.UPLOAD_UPDATE_DEPOSIT]: shop => shop.enableUploadFile,
  //setting
  [PERMISSIONS.SETTING_SHORTCUT_VIEW]: shop => shop.isShortcut,
  [PERMISSIONS.SETTING_SHORTCUT_EDIT]: shop => shop.isShortcut,
  [PERMISSIONS.SETTING_LINE_VIEW]: shop => shop.enableLineNotification,
  [PERMISSIONS.SETTING_LINE_EDIT]: shop => shop.enableLineNotification,

  //auto promotion
  [PERMISSIONS.AUTO_PROMOTION_VIEW]: shop => shop.enableAutoPromotion,
  [PERMISSIONS.AUTO_PROMOTION_CREATE]: shop => shop.enableAutoPromotion,
  [PERMISSIONS.AUTO_PROMOTION_EDIT]: shop => shop.enableAutoPromotion,
  [PERMISSIONS.AUTO_PROMOTION_CHANGE_STATUS]: shop => shop.enableAutoPromotion
};

const MODULE_GATE = {
  AI: shop => shop?.enableAI,
  SMART_POS: shop => shop?.enableSmartPos,
  MINIPOS: shop => shop?.enableMiniPos,
  BRANCH: shop => shop?.maxNumberOfBranches > 1,
  CONTACT: shop => shop?.contactEnabled,
  BROADCAST: shop => shop?.enableWhatsapp || shop?.enableLineNotification,
  SHOP_PRODUCT: shop => shop?.enableShoppingCart,
  SHOPPING_CART: shop => shop?.enableShoppingCart,
  BOOKING: shop => shop?.isBooking,
  BOOKING2: shop => shop?.isBooking2,
  PACKAGE: shop => shop?.enablePackage,
  PROMOTION: shop => shop?.enablePromotion,
  COUPON: shop => shop?.enableCoupon,
  RECOMMENDER_QR: shop => shop?.enableSalesQr,
  MGM: shop => shop?.enableMGM,
  FUNSHARING: shop => shop?.enableFunsharing,
  WALLET: shop => shop?.enableWallet,
  UPLOAD: shop => shop?.enableUploadFile,
  AUTO_PROMOTION: shop => shop?.enableAutoPromotion
};

export { ROLE_GATE, MODULE_GATE };
